import { CarouselComponent } from 'src/scripts/components/carousel'
import { BaseComponent } from '../../components/base-component'
import { $el } from 'src/scripts/utils/utils'
import { EmblaCarouselType } from 'embla-carousel'

const ANIMATE_IMAGES_ATTRIBUTE = 'data-animate-images'
const SLIDE_ANIMATED_CLASSNAME = 'slideshow__slide--animated'

export class SlideshowComponent extends BaseComponent {
  withImagesAnimated: boolean

  constructor() {
    super()
    this.withImagesAnimated = this.hasAttribute(ANIMATE_IMAGES_ATTRIBUTE)
  }

  mountComponent(): void {
    if (!this.withImagesAnimated) {
      return
    }

    const carousel: CarouselComponent = $el('carousel-component', this)

    if (carousel) {
      carousel.embla
        .slideNodes()
        [carousel.embla.selectedScrollSnap()].classList.add(
          SLIDE_ANIMATED_CLASSNAME,
        )

      carousel.embla.on('select', this.handleCarouselSelect)
    }
  }

  handleCarouselSelect = (data: EmblaCarouselType) => {
    data
      .slideNodes()
      [data.previousScrollSnap()].classList.remove(SLIDE_ANIMATED_CLASSNAME)

    data
      .slideNodes()
      [data.selectedScrollSnap()].classList.add(SLIDE_ANIMATED_CLASSNAME)
  }
}
